import React from 'react';
import { observer } from 'mobx-react-lite';
import Select, { createFilter } from 'react-select';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../mobx/bridge';
import styles from './LoginScreen.module.css';
import commonStyles from '../../../../assets/stylesheets/common.module.css';
import connectSMSLogo from '../../../../assets/images/connect-chat-logo.svg';
import * as utils from '../../../../helpers/utils';

const stringify = (option) => option.label;
const filterOption = createFilter({ stringify });

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const LocationPicker = observer(function LocationPicker() {
  const { commonStore } = useRootStore();
  const [dropdownLocations] = React.useState(
    commonStore.locations.map((data) => ({
      value: data,
      label: data.LocationName,
    }))
  );
  const { t } = useTranslation();

  const setInitialValue = () => {
    const incSelectedOption = commonStore.userPreviousLoginInfo?.LastLoggedLocationId
      ? dropdownLocations.find(
          (f) =>
            f.value.CPLocationID.toString() ===
            commonStore.userPreviousLoginInfo.LastLoggedLocationId.toString()
        )
      : null;

    if (incSelectedOption) {
      commonStore.setSelectedLocation(incSelectedOption.value);
    }

    return incSelectedOption;
  };

  const [selectedOption, setSelectedOption] = React.useState(setInitialValue);

  const onLocationChangedHandler = (option) => {
    setSelectedOption(option);
    commonStore.setSelectedLocation(option.value);
  };

  const onLocationSubmitHandler = (event) => {
    event.preventDefault();
    commonStore.setLoggedIn(true);
    commonStore.setConnectToLocationSocket();
  };

  return (
    <div className={styles.loginContainer} data-testid="locationPickerContainer">
      <form onSubmit={onLocationSubmitHandler} className={styles.locationChoiceContainer}>
        <img src={connectSMSLogo} alt="logo" className={commonStyles.connectSMSLogo} />

        <h4>{t('LocationPicker.SelectLocation')}</h4>

        <Select
          filterOption={filterOption}
          value={selectedOption}
          onChange={onLocationChangedHandler}
          options={dropdownLocations}
          id="locationPicker"
          aria-label="Location Picker Dropdown"
        />

        <input
          type="submit"
          value={t('Common.Connect')}
          disabled={!selectedOption}
          className={styles.loginSubmitBtn}
          data-testid="submitBtn"
        />

        {!commonStore.cpHeaderHeight && !utils.inIframe() ? (
          <input
            type="button"
            value={t('Common.LogOut')}
            onClick={commonStore.setLogoutStatus}
            className={styles.loginSubmitBtn}
            data-testid="logoutBtn"
          />
        ) : null}
      </form>
    </div>
  );
});
LocationPicker.whyDidYouRender = true;
LocationPicker.displayName = 'LocationPicker';

export default LocationPicker;
